const jumpBar = document.querySelector('.jump-bar');
const jumpBarContainer = document.querySelector('.jump-bar__container');
const header = document.querySelector('.site-header');
let jumpBarTop =
  jumpBar.offsetTop + jumpBarContainer.offsetTop - header.offsetHeight;

function jumpBarInit() {
  jumpBarTop =
    jumpBar.offsetTop + jumpBarContainer.offsetTop - header.offsetHeight;
  if (window.innerWidth < 1024) {
    jumpBarTop += 1;
  }
}

function jumpBarScroll() {
  if (window.scrollY > jumpBarTop) {
    document.querySelector('#main').classList.add('is-scrolled-past-header');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-past-header');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  jumpBarInit();
  jumpBarScroll();
});

document.addEventListener('scroll', function (e) {
  jumpBarScroll();
});

window.addEventListener('resize', () => {
  jumpBarInit();
  jumpBarScroll();
});
